import {i18n} from 'src/i18n';
import layoutActions from 'src/modules/layout/layoutActions';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';
import TareaService from 'src/modules/tarea/tareaService';
import Message from 'src/view/shared/message';

import moment from 'moment-timezone';
import taskFormListActions from '../list/taskFormListActions';

const prefix = 'TASKFORM_FORM';

const taskFormFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  //SET_RECORD: `${prefix}_SET_RECORD`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: taskFormFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TareaService.find(id);
      }

      dispatch({
        type: taskFormFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: taskFormFormActions.INIT_ERROR,
      });

      getHistory().push('/formularios');
    }
  },

  doCreate:
    (values, redirect = true) =>
    async (dispatch) => {
      try {
        dispatch({
          type: taskFormFormActions.CREATE_STARTED,
        });

        await TareaService.create(values);

        dispatch({
          type: taskFormFormActions.CREATE_SUCCESS,
        });

        Message.success(i18n('entities.taskForm.create.success'));

        //console.log('%c⧭ values.silent', 'color: #ffa280', values.silent);
        if (!values.silent && redirect) {
          getHistory().push('/formularios');
        }
        dispatch(
          layoutActions.doVisibleDrawer({
            drawerId: values.drawerId || 'DrawerTaskFormListPage',
            drawerVisible: false,
            drawerChanged: moment().unix(),
            drawerUpdateComponent: values.drawerUpdateComponent || 'TaskFormListPage',
          }),
        );
        return true;
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: taskFormFormActions.CREATE_ERROR,
        });
        return false;
      }
    },

  doUpdate:
    (id, values, edited: any = null) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: taskFormFormActions.UPDATE_STARTED,
        });

        await TareaService.update(id, values);

        if (edited) edited(id, values);

        dispatch({
          type: taskFormFormActions.UPDATE_SUCCESS,
        });
        if (id) {
          dispatch({
            type: taskFormListActions.PATCH_RECORD,
            payload: {id, values},
          });
        }

        if (!values.silent) {
          Message.success(i18n('entities.taskForm.update.success'));
        }

        // getHistory().goBack();
        const pathname = getHistory().location.pathname;
        if (!values.updating) {
          const now = Date.now();
          if (pathname.includes('taskForm')) {
            dispatch(
              layoutActions.doVisibleDrawer({
                drawerId: 'DrawerTareaListPage',
                drawerVisible: false,
                drawerChanged: now,
                drawerUpdateComponent: values?.drawerUpdateComponent || 'TareaListPage',
              }),
            );
          }
          if (pathname.includes('pendiente')) {
            dispatch(
              layoutActions.doVisibleDrawer({
                drawerId: 'DrawerTareaFormPage',
                drawerVisible: false,
                drawerChanged: now,
                drawerUpdateComponent: 'PendienteListPage',
              }),
            );
          }
        }
        return true;
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: taskFormFormActions.UPDATE_ERROR,
        });
        return false;
      }
    },
  setRecord: (values) => async (dispatch) => {
    try {
      dispatch({
        type: taskFormFormActions.INIT_SUCCESS,
        payload: values,
      });
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: taskFormFormActions.INIT_ERROR,
      });
    }
  },
};

export default taskFormFormActions;
